import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import { useConnection } from '@/hooks/use-connection';
import { LoadingSpinner } from './LoadingSpinner';
import { Body } from './ui/Typography';
const ConnectionInfo = () => {
  const { clientId, connectionId } = useParams<{ clientId: string; connectionId: string }>();
  const { connection, isLoadingConnection, connectionError } = useConnection(clientId!, connectionId!);

  if (isLoadingConnection) {
    return <LoadingSpinner />;
  }

  if (connectionError) {
    return <Alert severity="error">Failed to fetch connection info</Alert>;
  }

  if (!connection) {
    return <Alert severity="warning">No connection information available</Alert>;
  }

  return (
    <div className='flex flex-col gap-1 py-1'>
      <Body className='font-semibold'>Company Name: {connection.companyName}</Body>
      <Body>Organization Number: {connection.organizationNumber}</Body>
    </div>
  );
};

export default ConnectionInfo;